export const docLink = (target: string, doc = "Troubleshooting") =>
  `https://triangle.haelp.dev/documents/${doc}.html#md:${target}`;
